<!-- Announcement -->
@if (announcement()?.message) {
<announcement-bar [announcement]="announcement()"></announcement-bar>
}

<div class="main-container">
    <div class="product-detail-section">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 p-0 sticky-content">
                <!-- Image Viewer-->
                <base-image-viewer [imagesList]="productData().images" (openImagesInFullScreen$)="openImagesInFullScreen($event, productData())" (openImagesInFullScreenInMobile$)="openImagesInFullScreenInMobile($event, productData())"></base-image-viewer>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 ps-lg-5 ps-xl-5 mt-2 mt-sm-2 mt-md-2 mt-lg-0 mt-xl-0 product-detail-container">
                <div [class.page-mask]="pageMask()">
                    <!-- Deal Countdown -->
                    @if (remainingTime(); as remainingTime) { @if (remainingTime.remainingTime > 1000 &&
                    storeConfiguration()?.is_deal_active) {
                    <p class="countdown-info">
                        {{ productDealCountDown()?.badge_message }}
                        <strong @if(remainingTime.daysToToday)>{{ remainingTime.daysToToday }}</strong>
                        {{ remainingTime.daysToToday > 0 ? 'd :' : '' }}
                        <strong @if(remainingTime.hoursToToday)>{{ remainingTime.hoursToToday }}</strong>
                        {{ remainingTime.hoursToToday > 0 ? 'h :' : '' }}
                        {{ remainingTime.minutesToToday }}m : {{ remainingTime.secondsToToday }}s
                    </p>
                    } }

                    <!-- Product Name -->
                    <h1 class="product-name" [ngClass]="{
              'mt-6': isDealAvailable(),
              'mt-10': !isDealAvailable(),
              'mb-10': !productData()?.brand?.name,
              'mb-0': productData()?.brand?.name
            }">
                        {{ productData()?.display_name || productData()?.name }}
                    </h1>

                    <!-- one line description -->
                    @if (validDescription()) {
                    <base-short-description [description]="productData().one_line_description"></base-short-description>
                    }

                    <!-- brand link -->
                    @if (productData()?.brand?.name) {
                    <p class="brand-link">
                        <span class="opacity-75">By </span>
                        <span class="brand-name" [routerLink]="['/search']" [queryParams]="{
                brand_id: productData()?.brand?.id,
                brand_name: productData()?.brand?.name,
                utm_source: 'home',
                utm_medium: productData()?.brand?.name || ''
              }">
                            {{ productData()?.brand?.name }}</span>
                    </p>
                    }

                    <!-- sku -->
                    <h3 class="sku">
                        SKU: <span> {{ productData()?.sku }}</span>
                    </h3>

                    <!-- Tags -->
                    @if (productData()?.tags?.length) {
                    <div class="d-flex flex-wrap">
                        @for (tag of productData().tags; track $index) {
                        <base-tag [tagInput]="tag" [indexInput]="$index"></base-tag>
                        }
                    </div>
                    }

                    <!-- Product pricing -->
                    <div class="product-pricing-section">
                        <div class="d-flex align-items-center">
                            @if (sellingPrice() < actualPrice()) { <span class="selling-price">{{ sellingPrice() | indianCurrency }}</span>

                                <!-- actual price -->
                                @if (actualPrice() | percentageDiscount : sellingPrice(); as percentageDiscount) {
                                <span class="discount-percentage">{{ percentageDiscount }}</span>
                                } } @else {
                                <span class="product-price">{{ sellingPrice() | indianCurrency }}</span>
                                }
                        </div>

                        <!-- product mrp -->
                        <label>
                            MRP:
                            <span class="mrp-result" [ngClass]="{
                  'strike-through': sellingPrice() < actualPrice()
                }">{{ productData().mrp | indianCurrency }}</span>
                        </label>
                        <p class="tax-terms">Inclusive of all taxes</p>
                    </div>

                    <!-- Cash Points section -->
                    @if ((productPriceList() | cashpoints) > 0 &&
                    storeConfiguration()?.is_cashpoints_offer_active) {
                    <div class="d-flex align-items-center cash-point-section">
                        <p>Earn</p>
                        <cash-point-svg width="20" height="20"></cash-point-svg>
                        <p>{{ (productPriceList() | cashpoints) + ' CashPoints' }}</p>
                        <div class="d-flex align-items-center info-icon-container info-tooltip">
                            <img src="/assets/images/information-icon.png" class="info-icon" />
                            <div class="info-tooltip tool-tip-text">
                                Redeem these CashPoints later & avail exciting offers.
                            </div>
                        </div>
                    </div>
                    }

                    <!-- Dynamic Variants -->
                    <ul class="non-animated-scrollable-list">
                        @if (productData()?.variant_values?.length) {
                        <li>
                            <webstore-dynamic-variants [attributeSelectionsInput]="currentAttributeSelections()" [productInput]="productData() || null"></webstore-dynamic-variants>
                        </li>
                        } @if (availableOffers().length) {
                        <li>
                            <base-product-available-offers [availableOffersInput]="availableOffers()"></base-product-available-offers>
                        </li>
                        }

                        <!-- Cart -->
                        <li>
                            <ng-template [ngTemplateOutlet]="Cart"></ng-template>
                        </li>

                        @if (badges().length) {
                        <li>
                            <webstore-product-badge [badgesInput]="badges()"></webstore-product-badge>
                        </li>
                        } @if (showGptWidgets()) {
                        <li>
                            <webstore-chat-gpt></webstore-chat-gpt>
                        </li>
                        } @if (showProductDetails()) {
                        <li>
                            <dimension-and-weight [product]="productData()"></dimension-and-weight>
                        </li>
                        } @if (productData()?.highlights?.length) {
                        <li>
                            <base-highlights [highlights]="productData()?.highlights || []"></base-highlights>
                        </li>
                        }
                    </ul>

                    <!-- Animate scrollable list - Additional Product Details -->
                    <ul class="more-details-section">
                        <!-- Explore -->
                        <li class="pt-0">
                            <base-explore [productInput]="productData()" (scrollToSection$)="scrollToSection($event)"></base-explore>
                        </li>

                        <!-- Accessories -->
                        @if (isBrowser) { @if (productAccessories().response.length) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.Accessories">
                            <webstore-related-products-wrapper [heading]="ScrollAbleSectionViewLabels.Accessories" [products]="productAccessories()"></webstore-related-products-wrapper>
                        </li>
                        } }

                        <!-- Description -->
                        @if (productShortDescription()) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.Description">
                            <base-description [description]="productShortDescription()"></base-description>
                        </li>
                        }

                        <!-- Frequently Bought Together -->
                        @if (isBrowser) { @if (productFrequentlyBoughtTogether().response.length) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.FrequentlyBoughtToTogether">
                            <webstore-related-products-wrapper [heading]="ScrollAbleSectionViewLabels.FrequentlyBoughtToTogether" [products]="productFrequentlyBoughtTogether()"></webstore-related-products-wrapper>
                        </li>
                        } }

                        <!-- Specification -->
                        @if (productSpecifications().response.length) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.Specifications">
                            <base-specifications [specifications]="productSpecifications().response"></base-specifications>
                        </li>
                        }

                        <!-- Similar Products -->
                        @if (isBrowser) { @if (productSimilarProducts().response.length) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.SimilarProducts">
                            <webstore-related-products-wrapper [heading]="ScrollAbleSectionViewLabels.SimilarProducts" [products]="productSimilarProducts()"></webstore-related-products-wrapper>
                        </li>
                        } }

                        <!-- Products In A Box -->
                        @if (productsInABoxCondition()) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.ProductsInBox">
                            <webstore-loading-states-wrapper heading="Products In The Box" [state]="productsInABoxStateWrapper()">
                                <base-products-in-box [productsInABox]="productsInABoxState()"></base-products-in-box>
                            </webstore-loading-states-wrapper>
                        </li>
                        }

                        <!-- Features -->
                        @if (productFeatures().length) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.Features">
                            <webstore-loading-states-wrapper heading="Features" [state]="productFeaturesState()">
                                <base-features [features]="productFeatures()"></base-features>
                            </webstore-loading-states-wrapper>
                        </li>
                        }

                        <!-- Sponsored Products -->
                        @if (isBrowser) { @if (productSponsoredProducts().response.length) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.SponsoredProducts">
                            <webstore-related-products-wrapper [heading]="ScrollAbleSectionViewLabels.SponsoredProducts" [products]="productSponsoredProducts()"></webstore-related-products-wrapper>
                        </li>
                        } }

                        <!-- Downloads -->
                        @if (productDownloads() && (productDownloads().catalog?.length ||
                        productDownloads().howToGuide?.length || productDownloads().price_list?.length ||
                        productDownloads().user_manuals?.length)) {
                        <li #scrollAble [attr.id]="ScrollAbleSectionIds.Downloads">
                            <webstore-loading-states-wrapper heading="Downloads" [state]="productDownloadsState()">
                                <base-downloads [downloads]="productDownloads()"></base-downloads>
                            </webstore-loading-states-wrapper>
                        </li>
                        }

                        <!-- Images & Videos -->
                        @if (productAssetsShared() && (productAssetsShared()?.images?.others?.length ||
                        productAssetsShared()?.videos?.featured?.length)) {
                        <webstore-loading-states-wrapper heading="Images & Videos" [state]="productAssetsState()">
                            @if (productAssetsShared()?.images?.others?.length) {
                            <li #scrollAble [attr.id]="ScrollAbleSectionIds.Images">
                                <!-- Images -->
                                <base-images [featuredImages]="productAssetsShared()?.images?.others || []"></base-images>
                            </li>
                            } @if (productAssetsShared()?.videos?.featured?.length) {
                            <li #scrollAble [attr.id]="ScrollAbleSectionIds.Videos">
                                <!-- Videos -->
                                <base-videos [videosInput]="productAssetsShared()?.videos?.featured"></base-videos>
                            </li>
                            }
                        </webstore-loading-states-wrapper>
                        }
                    </ul>
                </div>
            </div>
        </div>

        <ng-template #Cart>
            <webstore-product-cart-configuration [errorMessage]="errorMessage()" (addToCart$)="addToCart($event)" (buyNow$)="buyNow($event)" (refetchProduct$)="refetchProduct$.emit(true)" [productInput]="productData()" [showEstimatedDelivery]="showEstimatedDeliveryValue()"></webstore-product-cart-configuration>
        </ng-template>
    </div>
</div>

<!-- Placeholder for full screen display of graphs -->
<ng-template webstoreFullscreenHost></ng-template>